import React from "react";
import "./Css/About.css";

const About = () => {
  return (
    <div className="about-page">

      <div className="about-container">
        
        <h1 className="about-title">About Atharva Kunal Prakashan</h1>

        <p>
          Atharva Kunal Prakashan was established with the vision of making 
          students' educational journey easier and more successful. In the 
          beginning, we started with a limited number of books, but due to the 
          positive response from students and the trust of parents, the 
          publication has grown consistently over time.
        </p>

        <p>
          We believe that education is not just about providing information; 
          it is a powerful tool to develop children’s thinking abilities. With 
          this belief, every book we create is designed carefully to support 
          students in their learning process.
        </p>

        <p>
          Our books are written in simple language, with clear explanations 
          and attractive layouts, helping students not only in their regular 
          studies but also in preparing for competitive examinations.
        </p>

        <p>
          We have always made sincere efforts to ensure that quality 
          educational materials reach students in rural areas as well. Over 
          the years, Atharva Kunal Prakashan has brought positive change to 
          the educational lives of thousands of students.
        </p>

        <p className="about-highlight">
          Today, we proudly say that our books are not just study materials 
          but true companions that inspire students to develop a love for 
          learning and knowledge.
        </p>

      </div>

    </div>
  );
};

export default About;